/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
define(["ol", "./ZoomLevelIndicator", "./BasemapSelector"], function(ol, ZoomLevelIndicator, BasemapSelector) {

	var Viewer = function(){};

	Viewer.prototype.setMap = function(containerComponent, lat, lon, zoom){
        /**
         * Create an overlay to anchor the popup to the map.
         */
        this.popupOverlay = new ol.Overlay({ stopEvent: true });
        
        /***************************************************/
		var el = containerComponent.body.dom;
		
		this.map = new ol.Map({
			layers: [
				new ol.layer.Tile({
					name: 'basemap',
					source: new ol.source.XYZ({
						url: 'https://api.maptiler.com/maps/voyager/256/{z}/{x}/{y}.png?key=6KOrA36ako66e9qWcbz8',
						crossOrigin: 'anonymous',
						attributions: '© MapTiler © OpenStreetMap contributors'
					    })
					})
			],
			controls: ol.control.defaults({
				attributionOptions: /** @type {olx.control.AttributionOptions} */ ({
					collapsible: false
				})
			}).extend([
				new BasemapSelector()
			]),
			target: el,
			overlays: [this.popupOverlay],
			view: new ol.View({
				multiWorld: true,
				constrainOnlyCenter: true,
				center: [lat, lon], 
				zoom: zoom,
				constrainResolution: true,
				enableRotation: false,
				minZoom: 1,
				maxZoom: 20,
				extent: ol.proj.get("EPSG:3857").getExtent()
			}),
	    });
		
		
		containerComponent.on('resize', function() {
			this.map.updateSize();
		}, this);
	};

	return Viewer;
});
